import script from "./TextWithNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./TextWithNotes.vue?vue&type=script&setup=true&lang=js"

import "./TextWithNotes.vue?vue&type=style&index=0&id=5166a16f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5166a16f"]])

export default __exports__